import React, { useState } from "react";
import Card from "../../../components/ui/Card";
import { Package, Truck, CheckCircle, Clock } from "lucide-react";

const OrdersPage = () => {
  const [orders] = useState([
    {
      id: "order_1",
      product: "Gigi Kiya - Signed Album",
      creator: "Gigi Kiya",
      amount: 350,
      status: "Delivered",
      orderDate: "Nov 15, 2025",
      deliveryDate: "Nov 22, 2025",
      trackingNumber: "ET-1234567890"
    },
    {
      id: "order_2",
      product: "DJ Habesha - Mix Pack",
      creator: "DJ Habesha",
      amount: 150,
      status: "Shipped",
      orderDate: "Nov 20, 2025",
      estimatedDelivery: "Nov 28, 2025",
      trackingNumber: "ET-0987654321"
    },
    {
      id: "order_3",
      product: "Fitness Guide E-book",
      creator: "Fit Coach Abel",
      amount: 85,
      status: "Processing",
      orderDate: "Nov 25, 2025"
    }
  ]);

  const statusConfig = {
    Processing: { icon: Clock, color: "text-yellow-600", bg: "bg-yellow-50" },
    Shipped: { icon: Truck, color: "text-blue-600", bg: "bg-blue-50" },
    Delivered: { icon: CheckCircle, color: "text-green-600", bg: "bg-green-50" }
  };

  return (
    <div className="min-h-screen bg-slate-50 p-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-slate-800 mb-6">My Orders</h1>

        <div className="space-y-4">
          {orders.map(order => {
            const StatusIcon = statusConfig[order.status].icon;
            return (
              <Card key={order.id} className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-start space-x-4">
                    <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center">
                      <Package size={32} className="text-purple-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-800">{order.product}</h3>
                      <p className="text-sm text-slate-500">by {order.creator}</p>
                      <p className="text-sm text-slate-600 mt-1">Order #{order.id}</p>
                    </div>
                  </div>
                  <div className={`px-3 py-1.5 rounded-full flex items-center space-x-2 ${statusConfig[order.status].bg}`}>
                    <StatusIcon size={16} className={statusConfig[order.status].color} />
                    <span className={`text-sm font-semibold ${statusConfig[order.status].color}`}>
                      {order.status}
                    </span>
                  </div>
                </div>

                <div className="grid md:grid-cols-3 gap-4 text-sm">
                  <div>
                    <p className="text-slate-500">Order Date</p>
                    <p className="font-medium text-slate-800">{order.orderDate}</p>
                  </div>
                  <div>
                    <p className="text-slate-500">Amount</p>
                    <p className="font-medium text-slate-800">{order.amount} ETB</p>
                  </div>
                  <div>
                    <p className="text-slate-500">{order.deliveryDate ? 'Delivered' : 'Estimated Delivery'}</p>
                    <p className="font-medium text-slate-800">
                      {order.deliveryDate || order.estimatedDelivery || 'TBD'}
                    </p>
                  </div>
                </div>

                {order.trackingNumber && (
                  <div className="mt-4 pt-4 border-t border-slate-200">
                    <p className="text-sm text-slate-500">Tracking Number</p>
                    <p className="font-mono text-sm font-medium text-slate-800">{order.trackingNumber}</p>
                  </div>
                )}

                <div className="mt-4 flex space-x-3">
                  <button className="text-sm text-primary hover:underline">View Details</button>
                  {order.status === 'Delivered' && (
                    <button className="text-sm text-primary hover:underline">Leave Review</button>
                  )}
                </div>
              </Card>
            );
          })}
        </div>

        {orders.length === 0 && (
          <Card className="p-12 text-center">
            <Package size={64} className="mx-auto mb-4 text-slate-300" />
            <h3 className="text-lg font-semibold text-slate-800 mb-2">No Orders Yet</h3>
            <p className="text-slate-600">Start shopping to see your orders here</p>
          </Card>
        )}
      </div>
    </div>
  );
};

export default OrdersPage;
